
<template>
  <div>
    <div v-for="data in datas">
      <div v-if="!data.pList || data.pList.length==0 && data.idx != 1264 && data.idx != 1493 && data.idx != 600"> <!-- banner -->
        <img :src="updatePicSrc(data.imgUrl)" width="100%" @click="redirect(data.openUrl,data)"/>
      </div>

      <!-- 畅销新品 女||男 -->
      <div v-if="data.pList && data.pList.length>0 && ( data.idx == 1200 || data.idx == 1490 )">
        <img :src="updatePicSrc(data.imgUrl)" style="width:97vw;margin-left:3vw">
        <div style="width: 94vw;padding-left: 3vw">
          <img v-for="d in getGoods2Show(data)" :src="updatePicSrc(d.headImage_s)" style="width: 47vw" @click="public.gotoDetail(d,public.headType.h5Main,d.idx)">
        </div>
        <div style="height: 5px;width: 100vw;background: #f8f8f8"></div>
      </div>

      <!-- 热门品类 女||男 -->
      <div v-if="data.idx == 600 || data.idx == 1493">
        <img :src="updatePicSrc(data.imgUrl)" style="width:97vw;margin-left:3vw">
        <div class="newHomePage_hotIdx">
            <div v-for="i in hotGoodsIdx" class="hotIdx" @click="gotoRecomend(i)">
              <div class="title">{{i.title}}</div>
              <div class="desc">{{i.desc}}</div>
              <img :src="updatePicSrc(i.imgUrl)" class="img"/>
            </div>
        </div>
        <div style="height: 5px;width: 100%;background: #f8f8f8"></div>
      </div>

      <!--( 超值特惠 女||男 ) || ( 排行榜 女||男 ) || (一元包邮)-->
      <!--<div v-if="data.pList && data.pList.length>0 && (( data.idx == 601 || data.idx == 1491 ) || ( data.idx == 1221 || data.idx == 1492 ) || (data.idx == 602) )">-->
      <!--( 超值特惠 女||男 ) || ( 旧排行榜 女||男 -6个商品) || ( 新排行榜 女||男 -1个商品暂时不用) || (9.9包邮)-->
      <div v-if="data.pList && data.pList.length > 0 && (data.idx == 601 || data.idx == 1491 || data.idx == 1221 || data.idx == 1492 || data.idx == 1789 ) ">
        <img :src="updatePicSrc(data.imgUrl)" style="width:97vw;margin-left:3vw" @click="gotoRecomend(data)">
        <div class="newHomePage_box">
          <div v-for="d in getGoods2Show(data)" class="show" @click="public.gotoDetail(d,public.headType.h5Main,d.idx)">
            <img :src="updatePicSrc(d.Pic)" class="goodsPic">
            <div class="title">{{d.sTitle ? d.sTitle : d.D_title}}</div>
            <div class="priceBox">
              <div class="price">¥{{d.Price}}</div>
              <div class="quanPrice" v-show="d.Quan_price > 0">{{parseFloat(d.Quan_price)}}元券</div>
            </div>
          </div>
        </div>
        <div style="height: 5px;width: 100%;background: #f8f8f8"></div>
      </div>

      <!-- 京东优选 -->
      <div v-if="data.pList && data.pList.length>0 && ( data.idx == 1629 || data.idx == 1593 )">
        <img :src="updatePicSrc(data.imgUrl)" style="width:97vw;margin-left:3vw">
        <div class="newHomePage_box">
          <div v-for="d in getGoods2Show(data)" class="show" @click="public.gotoDetail(d,public.headType.h5Main,d.idx)">
            <img :src="updatePicSrc(d.Pic)" class="goodsPic">
            <div class="title">{{d.sTitle ? d.sTitle : d.D_title}}</div>
            <div class="priceBox">
              <div class="price">¥{{d.Price}}</div>
              <div class="JDQuanPrice" v-show="getJdReward(d) > 0">奖励{{getJdReward(d)}}元</div>
            </div>
          </div>
        </div>
        <div style="height: 5px;width: 100%;background: #f8f8f8"></div>
      </div>

      <!-- 好店推荐 -->
      <!--<div v-if="data.idx == 1264">-->
        <!--<img :src="updatePicSrc(data.imgUrl)" style="width:97vw;margin-left:3vw" @click="gotoRecomend(data)">-->
        <!--<div class="newHomePage_goodShop" v-for="g in goodShop">-->
           <!--<img class="img" :src="updatePicSrc(g.imgUrl)">-->
           <!--<div class="title">{{g.title}}</div>-->
           <!--<div class="desc">{{g.desc}}</div>-->
        <!--</div>-->
        <!--<div style="height: 5px;width: 100%;background: #f8f8f8"></div>-->
      <!--</div>-->

      <!-- 猜你喜欢 -->
      <div v-if="data.pList && data.pList.length>0 && data.idx == 1205">
        <img :src="updatePicSrc(data.imgUrl)" style="width:97vw;margin-left:3vw">
        <div class="newHomePage_box">
          <div v-for="d in getGoods2Show(data)" class="show" @click="public.gotoDetail(d,public.headType.h5Main,d.idx)">
            <img :src="updatePicSrc(d.Pic)" class="goodsPic">
            <div class="title">{{d.sTitle ? d.sTitle : d.D_title}}</div>
            <div class="priceBox">
              <div class="price">¥{{d.Price}}</div>
              <div class="quanPrice" v-show="d.Quan_price > 0">{{parseFloat(d.Quan_price)}}元券</div>
            </div>
          </div>
        </div>
        <div style="height: 5px;width: 100%;background: #f8f8f8"></div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    name:'NewHomePage',
    props:['datas','hotGoodsIdx','goodShop','jdShareRatio'],
    data(){
      return {
      }
    },
    created(){},
    filters:{

    },
    directives: {
      first: {
        bind: function (el, binding, vnode) {
        }
      }
    },
    mounted(){

    },
    components:{

    },
    methods:{
      redirect(url,banner){
        if(url && url.toLowerCase().indexOf("taobao") < 0){
          window.location.href = url;
        }else if(banner.param){
          this.jumpToView(this.headType.recommend,banner.param,banner.title?banner.title:"");
        }else if(!banner.param){
          this.jumpToView(this.headType.recommend,"",banner.title?banner.title:"");
        }else{
          console.warn("redirect url && param is undefined");
        }
      },
      updatePicSrc(pic){
        let src = pic.replace("http://", "//").replace("https://", "//");
        if (src.indexOf("taobaocdn.") > -1) {
          src = src.split("taobaocdn.")[1];
          src = "//img.alicdn." + src;
        }
        if (src.indexOf("alicdn") > -1) {
          src += "_300x300.jpg";
        }
        return src;
      },
      getJdReward(d){
        var res = parseFloat(d.Price) * this.jdShareRatio / 100 * d.CommissionNum / 100;
        res < 0.1 && ( res == 0.1 );
        res = `${res}`;
        res.split(".")[1] && res.split(".")[1].length > 2 && (res = res.split(".")[0] + "." + res.split(".")[1].slice(0,2));
        return res;
      },
      gotoRecomend(d){
        let title = d.title;
        if(d.idx==23 || d.idx==27){
          title = d.desc?d.desc:d.title;
        }
        this.jumpToView(this.headType.recommend,d.param,title);

        document.title = this.isWeixin ? title : title + "_一起买买买社交电商平台，yiqimmm.com天猫淘宝京东优惠券-一起买买买";
      },
      getGoods2Show(data){
        switch (data.idx){
          case 1200 : {}
          case 1490 : {
            return data.pList.slice(0,2);
            break;
          }
          case 600 : {}
          case 1493 : {
            //unused
            break;
          }
          case 601 : {}
          case 1491 : {
            return data.pList.slice(0,6);
            break;
          }
          // 旧排行榜
          case 1221 : {}
          case 1492 : {
            return data.pList.slice(0,6);
            break;
          }
          // 新排行榜
          // case 1787 : {}
          // case 1806 : {
          //   return data.pList.slice(0,1);
          //   break;
          // }
          case 602 : {
            return data.pList.slice(0,6);
            break;
          }
          case 1593 :{}
          case 1629 : {
            return data.pList.slice(0,6);
            break;
          }
          case 1264 : {
            //unused
            break;
          }
          case 1205 : {
            return data.pList.slice(0,parseInt(data.pList.length/3)*3);
            break;
          }
          default:{}
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// NewHomePage.vue?77b5aef1